import { HttpClient, HttpHeaders, HttpResponse, HttpEvent } from '@angular/common/http';
import { Injectable } from "@angular/core"; import { Location } from "@angular/common";

import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { ReponseBase } from './reponse-base';
import { RequisitionMin } from '../entites/requisition-min';
import { Requisition } from '../entites/requisition';
import { Commande } from '../entites/commande';
import { CommandeMin } from '../entites/commande-min';
import { RequeteObtenirCommande } from './requetes/requete-obtenir-commande';
import { ReponseObtenirCommande } from './reponses/reponse-obtenir-commande';
import { ItemCommandeEntite } from '../entites/item-commande';
import { RequeteCreerItemCommande } from './requetes/requete-creer-item-commande';
import { RequeteModifierItemCommande } from './requetes/requete-modifier-item-commande';
import { ReponseModifierItemCommande } from './reponses/reponse-modifier-item-commande';
import { EmplacementService } from './emplacement-service';
import { Emplacement } from '../entites/emplacement';
import { ReponseCreerItemCommande } from './reponses/reponse-creer-item-commande';
import { RequeteRemplacerItemCommande } from './requetes/requete-remplacer-item-commande';
import { TransporteurEntite } from '../entites/transporteur';
import { ItemService } from './item-service';
import { RequetePrecommandeEnChantier } from './requetes/requete-precommande-en-chantier';
import { CacheMap, SignalWithWatcher } from './base.service';
import { BaseService } from './base.service';
import { MessageService } from 'primeng/api';
import { HubConnection } from '@microsoft/signalr';
import { SihcHubService, SihcEvents } from './sihc-hub.service';
import { HistoriqueCommande } from '../entites/historique-commande';

@Injectable({ providedIn: 'root' })
export class CommandeService extends BaseService {

  private obtenirCommandeUrl = environment.apiBaseUrl + 'commande/{emplacementId}';
  private obtenirCommandeParDepartementUrl = environment.apiBaseUrl + 'commande/departement/{departementId}';
  private obtenirCommandeCompletUrl = environment.apiBaseUrl + 'commande/complet';
  private obtenirPrecommandeUrl = environment.apiBaseUrl + 'commande/emplacement/{emplacementId}';
  private obtenirApprobationsPrecommandeUrl = environment.apiBaseUrl + 'commande/approbations';
  private obtenirApprobationPrecommandeUrl = environment.apiBaseUrl + 'commande/{emplacementId}/approbation';
  private creerItemCommandeUrl = environment.apiBaseUrl + 'commande';
  private modifierItemCommandeUrl = environment.apiBaseUrl + 'commande/modifier';
  private modifierQteItemCommandeUrl = environment.apiBaseUrl + 'commande/modifierqte';
  private modifierAssignationItemCommandeUrl = environment.apiBaseUrl + 'commande/modifierassignation';
  private approuverItemPreCommandeUrl = environment.apiBaseUrl + 'commande/approuveritemprecommande';
  private remplacerItemCommandeUrl = environment.apiBaseUrl + 'commande/remplacerItemCommande';
  private supprimerItemCommandeUrl = environment.apiBaseUrl + 'commande/';
  private modifierCommandesActivesUrl = environment.apiBaseUrl + 'commande/commandesactives';
  private supprimerItemsUrl = environment.apiBaseUrl + 'commande/supprimerItems';
  private obtenirTransporteursUrl = environment.apiBaseUrl + 'commande/{emplacementId}/transporteurs';
  private envoyerCourrielPreCommandeApprobationUrl = environment.apiBaseUrl + 'commande/envoyerCourrielPreCommandeApprobation';
  private modifierItemPreCommandeUrl = environment.apiBaseUrl + 'commande/modifier-pre-commande/{id_item_commande}';
  private convertirItemPreCommandeADiversUrl = environment.apiBaseUrl + 'commande/convertirItemPrecommandeEnDivers/{id_item_commande}';
  private envoyerPrecommandeEnChantierUrl = environment.apiBaseUrl + 'commande/envoyerenchantier';
  private obtenirStatutsCommandeUrl = environment.apiBaseUrl + 'commande/emplacements';
  private obtenirHistoriqueCommandeUrl = environment.apiBaseUrl + 'commande/{emplacementId}/historique';
  private obtenirItemCommandeUrl = environment.apiBaseUrl + 'commande/{id}/details';

  private hubConnection: HubConnection;

  private commandesCache = new CacheMap<string, SignalWithWatcher<ReponseBase<ReponseObtenirCommande>>>(30);
  private precommandesCache = new CacheMap<string, SignalWithWatcher<ReponseBase<ReponseObtenirCommande>>>(30);
  private approbationsCache = new CacheMap<string, SignalWithWatcher<ReponseBase<Emplacement[]>>>(30);
  private itemsCommandeCache = new CacheMap<string, SignalWithWatcher<ReponseBase<ItemCommandeEntite[]>>>(30);
  private historiqueCommandeCache = new CacheMap<string, SignalWithWatcher<HistoriqueCommande[]>>(30);

  public httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  constructor(
    public itemService: ItemService,
    private http: HttpClient,
    public router: Router,
    public messageService: MessageService,
    private commandesHub: SihcHubService
  ) {
    super(messageService, router);
    this.hubConnection = this.commandesHub.connection;
    void this.commandesHub.subscribe('commandes');
  }

  public ObtenirCommande(emplacementId: number): Observable<SignalWithWatcher<ReponseBase<ReponseObtenirCommande>>> {
    return this.http.get<ReponseBase<ReponseObtenirCommande>>(this.obtenirCommandeUrl.replace('{emplacementId}', emplacementId.toString()))
      .pipe(
        catchError(error => this.handleError(error))
      )
      .watchUpdates({
        hub: {
          hubConnection: this.hubConnection,
          idField: 'commandeId',
          events: { add: SihcEvents.commandesAdd, update: SihcEvents.commandesUpdate, delete: SihcEvents.commandesDelete }
        },
        caching: {
          key: `commande-${emplacementId}`,
          cacheMap: this.commandesCache
        }
      });
  }

  public ObtenirCommandeParDepartement(departementId: number): Observable<SignalWithWatcher<ReponseBase<ReponseObtenirCommande>>> {
    return this.http.get<ReponseBase<ReponseObtenirCommande>>(this.obtenirCommandeParDepartementUrl.replace('{departementId}', departementId.toString()))
      .pipe(
        catchError(error => this.handleError(error))
      )
      .watchUpdates({
        hub: {
          hubConnection: this.hubConnection,
          idField: 'commandeId',
          events: { add: SihcEvents.commandesAdd, update: SihcEvents.commandesUpdate, delete: SihcEvents.commandesDelete }
        },
        caching: {
          key: `commande-dept-${departementId}`,
          cacheMap: this.commandesCache
        }
      });
  }

  public ObtenirCommandeComplet(transformFunction?: (data: ItemCommandeEntite[]) => ItemCommandeEntite[]): Observable<SignalWithWatcher<ItemCommandeEntite[]>> {
    return this.http.get<ItemCommandeEntite[]>(this.obtenirCommandeCompletUrl)
      .pipe(
        catchError(error => this.handleError(error))
      )
      .watchUpdates({
        hub: {
          hubConnection: this.hubConnection,
          idField: 'itemCommandeId',
          events: { add: SihcEvents.commandesAdd, update: SihcEvents.commandesUpdate, delete: SihcEvents.commandesDelete }
        },
        transformFunction: transformFunction,
        caching: {
          key: 'commandes-complet',
          cacheMap: this.itemsCommandeCache
        }
      });
  }

  public ObtenirPrecommande(emplacementId: number, transformFunction?: (data: ReponseBase<ReponseObtenirCommande>) => ReponseBase<ReponseObtenirCommande>): Observable<SignalWithWatcher<ReponseBase<ReponseObtenirCommande>>> {
    return this.http.get<ReponseBase<ReponseObtenirCommande>>(this.obtenirPrecommandeUrl
      .replace('{emplacementId}', emplacementId.toString()))
      .pipe(
        catchError(error => this.handleError(error))
      )
      .watchUpdates({
        hub: {
          hubConnection: this.hubConnection,
          idField: 'commandeId',
          events: { add: SihcEvents.commandesAdd, update: SihcEvents.commandesUpdate, delete: SihcEvents.commandesDelete }
        },
        caching: {
          key: `precommande-${emplacementId}`,
          cacheMap: this.precommandesCache
        },
        transformFunction: transformFunction
      });
  }

  public ObtenirApprobationsPrecommande(): Observable<ReponseBase<Emplacement[]>> {
    return this.http.get<ReponseBase<Emplacement[]>>(this.obtenirApprobationsPrecommandeUrl)
      .pipe(
        catchError(error => this.handleError(error))
      )
  }

  public ObtenirApprobationPrecommande(emplacementId: number): Observable<SignalWithWatcher<ReponseBase<ReponseObtenirCommande>>> {
    return this.http.get<ReponseBase<ReponseObtenirCommande>>(this.obtenirApprobationPrecommandeUrl.replace('{emplacementId}', emplacementId.toString()))
      .pipe(
        catchError(error => this.handleError(error))
      )
      .watchUpdates({
        hub: {
          hubConnection: this.hubConnection,
          idField: 'commandeId',
          events: { add: SihcEvents.commandesAdd, update: SihcEvents.commandesUpdate, delete: SihcEvents.commandesDelete }
        },
        caching: {
          key: `approbation-precommande-${emplacementId}`,
          cacheMap: this.precommandesCache
        }
      });
  }

  public ObtenirItemCommande(id: number): Observable<ItemCommandeEntite> {
    return this.http.get<ItemCommandeEntite>(this.obtenirItemCommandeUrl.replace('{id}', id.toString()))
      .pipe(
        catchError(error => this.handleError(error))
      );
  }

  public CreerItemCommande(requete: RequeteCreerItemCommande): Promise<ReponseBase<ReponseCreerItemCommande>> {
    var p = this.http.post<ReponseBase<ReponseCreerItemCommande>>(this.creerItemCommandeUrl, JSON.stringify(requete), this.httpOptions).toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public ModifierItemCommande(requete: RequeteModifierItemCommande): Promise<ReponseBase<ReponseModifierItemCommande>> {
    var p = this.http.post<ReponseBase<ReponseModifierItemCommande>>(this.modifierItemCommandeUrl, JSON.stringify(requete), this.httpOptions).toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public EnvoyerCourrielApprobation(requete: RequeteModifierItemCommande): Promise<ReponseBase<ReponseModifierItemCommande>> {
    var p = this.http.post<ReponseBase<ReponseModifierItemCommande>>(this.envoyerCourrielPreCommandeApprobationUrl, JSON.stringify(requete), this.httpOptions).toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public ModifierqteItemCommande(requete: RequeteModifierItemCommande): Promise<ReponseBase<ReponseModifierItemCommande>> {
    var p = this.http.post<ReponseBase<ReponseModifierItemCommande>>(this.modifierQteItemCommandeUrl, JSON.stringify(requete), this.httpOptions).toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public ModifierAssignationItemCommande(requete: RequeteModifierItemCommande): Promise<ReponseBase<ReponseModifierItemCommande>> {
    var p = this.http.post<ReponseBase<ReponseModifierItemCommande>>(this.modifierAssignationItemCommandeUrl, JSON.stringify(requete), this.httpOptions).toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public ApprouverItemPreCommande(requete: RequeteModifierItemCommande): Promise<ReponseBase<ReponseModifierItemCommande>> {
    var p = this.http.post<ReponseBase<ReponseModifierItemCommande>>(this.approuverItemPreCommandeUrl, JSON.stringify(requete), this.httpOptions).toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public RemplacerItemCommande(requete: RequeteRemplacerItemCommande): Promise<ReponseBase<boolean>> {
    var p = this.http.post<ReponseBase<boolean>>(this.remplacerItemCommandeUrl, JSON.stringify(requete), this.httpOptions).toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public SupprimerItemCommande(itemCommandeId: number): Promise<ReponseBase<boolean>> {
    var p = this.http.delete<ReponseBase<boolean>>(this.supprimerItemCommandeUrl + itemCommandeId).toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public ModifierCommandesActives(requete: Emplacement[]): Promise<ReponseBase<boolean>> {
    var p = this.http.post<ReponseBase<boolean>>(this.modifierCommandesActivesUrl, JSON.stringify(requete), this.httpOptions).toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public SupprimerItemsCommande(ids: number[]): Promise<ReponseBase<boolean>> {
    var p = this.http.post<ReponseBase<boolean>>(this.supprimerItemsUrl, JSON.stringify(ids), this.httpOptions).toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public ObtenirTransporteur(emplacementId: number): Promise<ReponseBase<TransporteurEntite[]>> {
    var p = this.http.get<ReponseBase<TransporteurEntite[]>>(this.obtenirTransporteursUrl.replace('{emplacementId}', emplacementId.toString()))
      .toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public ModifierItemPreCommande(idItemCommande: number, requete: RequeteCreerItemCommande): Promise<ReponseBase<ReponseModifierItemCommande>> {
    var p = this.http.put<ReponseBase<ReponseModifierItemCommande>>(this.modifierItemPreCommandeUrl.replace('{id_item_commande}', idItemCommande.toString()), JSON.stringify(requete), this.httpOptions).toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public ConvertirItemPreCommandeADivers(idItemCommande: number): Promise<ReponseBase<ReponseModifierItemCommande>> {
    var p = this.http.put<ReponseBase<ReponseModifierItemCommande>>(this.convertirItemPreCommandeADiversUrl.replace('{id_item_commande}', idItemCommande.toString()), null, this.httpOptions).toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public EnvoyerPrecommandeEnChantier(requete: RequetePrecommandeEnChantier): Observable<HttpResponse<RequisitionMin>> {
    return this.http.post<RequisitionMin>(this.envoyerPrecommandeEnChantierUrl, JSON.stringify(requete), { ...this.httpOptions, observe: 'response' });
  }

  public ObtenirStatsEmplacementCommandes(): Observable<SignalWithWatcher<Emplacement[]>> {
    return this.http.get<Emplacement[]>(this.obtenirStatutsCommandeUrl)
      .pipe(
        catchError(error => this.handleError(error))
      )
      .watchUpdates({
        hub: {
          hubConnection: this.hubConnection,
          idField: 'emplacementId',
          events: { add: SihcEvents.commandesAdd, update: SihcEvents.commandesUpdate, delete: SihcEvents.commandesDelete }
        },
        caching: {
          key: 'stats-emplacements-commandes',
          cacheMap: this.approbationsCache
        }
      });
  }

  public ObtenirHistoriqueCommande(emplacementId: number): Observable<SignalWithWatcher<HistoriqueCommande[]>> {
    return this.http.get<HistoriqueCommande[]>(this.obtenirHistoriqueCommandeUrl.replace('{emplacementId}', emplacementId.toString()))
      .pipe(
        catchError(error => this.handleError(error))
      )
      .watchUpdates({
        hub: {
          hubConnection: this.hubConnection,
          idField: 'historiqueCommandeId',
          events: { add: SihcEvents.commandesAdd, update: SihcEvents.commandesUpdate, delete: SihcEvents.commandesDelete }
        },
        caching: {
          key: `historique-commande-${emplacementId}`,
          cacheMap: this.historiqueCommandeCache
        }
      });
  }
}
